import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const swipeUp = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  10% {
    transform: translateY(0%);
    opacity: 1;
  }
  90% {
    transform: translateY(0%);
    opacity: 1;
  }
  100% {
    transform: translateY(-100%);
    opacity: 0;
  }
`;

const Wrapper = styled.div`
  height: 32px;
  background-color: ${colors.backgroundSurfaceSecondary};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
`;

const Text = styled.div`
  width: fit-content;
  font-size: ${fontSize.s};
  animation: ${swipeUp} 4s ease-in-out infinite;
  animation-delay: ${(props) => props.delay || 0}s;
  position: absolute;

  a {
    margin-left: 2px;
    text-decoration: underline;
    text-underline-offset: 2px;
    cursor: pointer;
  }
`;

function TopBar() {
  const promotionalTexts = [
    { text: "New Arrivals: Checkout the Latest Collection", link: "Shop Now" },
    {
      text: "Exclusive discounts waiting, Selected items only",
      link: "Order Now",
    },
    { text: "Sale on popular picks, Hurry before it's gone", link: "Explore" },
    {
      text: "Elevate your look with everyday wardrobe essentials",
      link: "Get Deal",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % promotionalTexts.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [promotionalTexts.length]);

  return (
    <Wrapper>
      <Text key={currentIndex}>
        {promotionalTexts[currentIndex].text}
        <span>{/* <a>{promotionalTexts[currentIndex].link}</a> */}</span>
      </Text>
    </Wrapper>
  );
}

export default TopBar;
